<div
  class="list-tasks-single-task {{ 'list-tasks-single-task--' + task()?.status }}"
  [ngClass]="{
    'list-tasks-single-task--subtask': isSubtask,
    'list-tasks-single-task--process-group': isProcessGroup(),
    'list-tasks-single-task--subtask-sidenav': simplifiedSubtaskLayout(),
    'list-tasks-single-task--card': isCardLayout(),
    'list-tasks-single-task--card-fields-hidden': isCardLayout() && !hasVisibleCardFields(),
    'list-tasks-single-task--project': isProjectLayout(),
    'list-tasks-single-task--sidenav-active': activeInSidenav()
  }"
  [style.--task-card-nesting-indent]="isCardLayout() ? cardNestingIndent + 'px' : null"
  [dndDraggable]="
    shouldBeDraggable() ? { taskId: task().id, sourceGroupId: groupId(), sourceStatus: status() } : null
  "
  [dndDisableIf]="isProcessGroup() || !shouldBeDraggable()"
  dndType="task"
  dndEffectAllowed="copyMove"
  (dndStart)="dragStart()"
  (dndDrag)="drag($event)"
  (dndEnd)="dragEnd()"
>
  <div class="list-tasks-single-task__container" dndDragImageRef dndHandle>
    @if (!isProcessGroup() && !simplifiedSubtaskLayout()) {
      <div class="drag-handle" [class.hidden]="!shouldBeDraggable()">
        <img draggable="false" width="12" src="./assets/img/ic-sortdragchange.svg" alt="drag-drop" />
      </div>
    }

    <div
      class="list-tasks-single-task__content"
      [ngClass]="'list-tasks-single-task__content--' + task()?.status"
      [class.list-tasks-single-task__content--completed]="isCompleted() || isSentProcessMessageLike()"
    >
      <div class="list-tasks-single-task__content__primary">
      <div class="list-tasks-single-task__content__leading">
      @if (!!parentTask() && !hideHierarchyIndicator()) {
        <div
          class="list-tasks-single-task__content__expander list-tasks-single-task__content__expander--subtask-leading"
          [style.margin-left.px]="isCardLayout() ? 0 : subtaskLeadingOffset"
        >
          <mat-icon class="subtask-icon">subdirectory_arrow_right</mat-icon>
        </div>
      }

      <div class="list-tasks-single-task__status-control">
        <button
          type="button"
          class="list-tasks-single-task__content__status-trigger"
          [ngClass]="getTaskTypeCssClass()"
          (click)="onStatusTriggerClick($event)"
        >
          <mat-icon>{{ getTaskTypeIcon() }}</mat-icon>
        </button>

        @if (statusPanelOpen) {
          <div
            class="list-tasks-single-task__status-panel list-tasks-single-task__status-panel--open"
            (click)="$event.stopPropagation()"
          >
            <div class="list-tasks-single-task__status-panel__track">
              @for (option of orderedStatusOptions; track option.id; let first = $first) {
                <button
                  type="button"
                  class="list-tasks-single-task__status-panel__option"
                  [ngClass]="getStatusOptionClasses(option.id, first)"
                  [attr.aria-label]="option.label | translate"
                  [attr.title]="option.label | translate"
                  (click)="onStatusOptionSelected(option.id)"
                >
                  <mat-icon>{{ getTaskStatusIcon(option.id) }}</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>

      <div
        class="list-tasks-single-task__content__assignee"
        [class.list-tasks-single-task__content__assignee--subtask-no-expander]="
          !!parentTask() && !task()?.childrenCount && !hideHierarchyIndicator()
        "
      >
        <avatar-multiple
          [assignSearchDropdownTask]="task()"
          [items]="assignedUsers"
          [width]="24"
          [disabledSearch]="false"
          (onAssignSearchDropdownTaskChange)="onAssignSearchDropdownTaskChange($event)"
        />
      </div>

      @if (!hideHierarchyIndicator() && (task()?.childrenCount || !parentTask())) {
        <div
          class="list-tasks-single-task__content__expander"
          [class.list-tasks-single-task__content__expander--subtask]="!!parentTask()"
        >
          @if (task()?.childrenCount) {
            <expander [opened]="task()?.openedSubtasks" (onClick)="toggleSubtasks()" />
          }
        </div>
      }
      </div>

      <div
        class="list-tasks-single-task__content__title d-flex {{
          'list-tasks-single-task__content__title--' + task()?.status
        }}"
      >
        @if ((task()?.priority ?? 4) < 4 && !isCardLayout()) {
          <svg-icon
            class="list-tasks-single-task__content__priority-icon"
            src="./assets/img/ic-arrow-up-task-priority.svg"
          />
        }

        <a draggable="false" href="javascript:void(0)" tooltipIfTruncated [matTooltip]="isCardLayout() ? task()?.description : ''" matTooltipPosition="above" (click)="previewTask($event)">
          {{ task()?.description }}
        </a>

        @if (task()?.hiddenForClient && !simplifiedSubtaskLayout() && !isCardLayout()) {
          <svg-icon
            [title]="'ProjectTasks.Task.hiddenFromClient' | translate"
            class="ml-1"
            src="./assets/img/ic-eye-off.svg"
            [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
          />
        }
      </div>
      </div>

      @if (task()?.type && !simplifiedSubtaskLayout() && !isCardLayout()) {
        <div class="list-tasks-single-task__content__type-tag" [ngClass]="getTaskTypeCssClass()">
          {{ getTaskTypeTranslationKey() | translate }}
        </div>
      }

      @if (isCardLayout() && hasVisibleCardFields()) {
        <div class="list-tasks-single-task__content__card-fields" [style.--task-card-grid-columns]="cardGridColumns()" (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()">
          @if (isMyWorkLayout() && myWorkColumns.isVisible('project')) {
            <div class="task-card-field task-card-field--project" [matTooltip]="myWorkProjectTooltip" matTooltipPosition="above">
              <span class="task-card-field__project-address"><span class="pii">{{ myWorkProjectAddress }}</span></span>
              <span class="task-card-field__project-client"><span class="pii">{{ myWorkProjectClient }}</span></span>
            </div>
          }

          @if (isCardColumnVisible('priority')) {
          <div class="task-card-field task-card-field--priority">
            <button type="button" class="task-card-field__control task-card-field__priority" [class.task-card-field__priority--sofort]="cardPriority === 1" [class.task-card-field__priority--dringend]="cardPriority === 2" [disabled]="prioritySaving || !canEditCardFields()" [matMenuTriggerFor]="priorityMenu" (click)="$event.stopPropagation()" [attr.aria-label]="'MyWork.Card.priorityLabel' | translate">
              @if (cardPriority !== 4) {
                <span class="task-card-field__priority-dot"></span>
                {{ 'MyWork.Card.priority.' + cardPriorityLabel | translate }}
              }
              <mat-icon>expand_more</mat-icon>
            </button>
            <mat-menu #priorityMenu="matMenu" class="menu-v2 task-card-priority-menu">
              @for (priority of cardPriorities; track priority) {
                <button mat-menu-item type="button" class="task-card-priority-option" (click)="onCardPrioritySelected(priority)">
                  <span class="task-card-priority-option__content" [class.task-card-priority-option__content--sofort]="priority === 1" [class.task-card-priority-option__content--dringend]="priority === 2" [class.task-card-priority-option__content--none]="priority === 4">
                    <span class="task-card-priority-option__dot"></span>
                    <span>{{ 'MyWork.Card.priority.' + priorityLabel(priority) | translate }}</span>
                  </span>
                </button>
              }
            </mat-menu>
          </div>
          }

          @if (isCardColumnVisible('minutes')) {
          <div class="task-card-field task-card-field--minutes">
            <input type="number" class="task-card-field__control task-card-field__minutes" [value]="task().estimatedTime ?? ''" [disabled]="minutesSaving || !canEditCardFields()" min="0" max="525600" step="1" (change)="onCardMinutesChanged($event)" (keydown)="onCardMinutesKeydown($event)" [attr.aria-label]="'MyWork.Card.minutes' | translate" />
            <span class="task-card-field__minutes-unit" aria-hidden="true">min</span>
          </div>
          }

          @if (isCardColumnVisible('deadline')) {
          <div class="task-card-field task-card-field--deadline">
            <button type="button" class="task-card-field__control task-card-field__deadline" [class.task-card-field__deadline--today]="cardDeadlineTone === 'today'" [class.task-card-field__deadline--past]="cardDeadlineTone === 'past'" [disabled]="deadlineSaving || !canEditCardFields()" [matTooltip]="cardDeadlineTooltip" (click)="openCardRangePicker(); cardRangePicker.open(); $event.stopPropagation()" [attr.aria-label]="'realizationTerm' | translate">
              <svg-icon src="./assets/img/calendar-v2-icon.svg" [svgStyle]="{ width: '18px', height: '18px' }" />
              <span>{{ cardDeadlineLabel }}</span>
            </button>
            <mat-date-range-input [rangePicker]="cardRangePicker" class="task-card-field__range-input">
              <input matStartDate [formControl]="rangeStart" />
              <input matEndDate [formControl]="rangeEnd" (dateChange)="onCardRangeEndChanged($event)" />
            </mat-date-range-input>
            <mat-date-range-picker #cardRangePicker />
            @if (task()?.termEnd) {
              <button type="button" class="task-card-field__clear" (click)="clearCardRange($event)" [disabled]="deadlineSaving || !canEditCardFields()" [attr.aria-label]="'MyWork.Card.clearDeadline' | translate">×</button>
            }
          </div>
          }

          @if (isCardColumnVisible('comment')) {
          <div class="task-card-field task-card-field--comment" [floatingPopoverTrigger]="cardLastComment() ? latestCommentPopoverTpl : null">
            {{ cardLastComment()?.content }}
          </div>
          }
        </div>
      }

      @if (shouldShowMyWorkProjectMeta && projectMetaInlineLabel && !isCardLayout()) {
        <div class="list-tasks-single-task__content__project-meta-inline">
          <span class="pii">{{ projectMetaInlineLabel }}</span>
        </div>
      }

      @if (task()?.childrenCount && !isCardLayout()) {
        <div class="list-tasks-single-task__content__amount cursor-pointer" (click)="toggleSubtasks()">
          <svg-icon [src]="'./assets/img/ic-subtask.svg'" [svgStyle]="{ width: '16px', height: '16px' }" />
          {{ task()?.completedChildrenCount ?? 0 }}/{{ task()?.childrenCount ?? 0 }}
        </div>
      }
    </div>

    @if (!isCardLayout()) {
    <div
      class="list-tasks-single-task__info flex-wrap"
      [class.list-tasks-single-task__info--completed]="isCompleted()"
      [class.list-tasks-single-task__info--completed-like]="isSentProcessMessageLike()"
      [class.list-tasks-single-task__info--cancelled]="task()?.status === 'cancelled'"
      [class.list-tasks-single-task__info--canceled]="task()?.status === 'canceled'"
    >
      @if (task()?.termEnd) {
        @if (showProcessDeadlineTag()) {
          <div
            class="list-tasks-single-task__info__deadline-tag"
            [class.list-tasks-single-task__info__deadline-tag--overdue]="isOverdue()"
          >
            @if (isOverdue()) {
              <mat-icon fontSet="material-icons-round" aria-hidden="true">schedule</mat-icon>
            }
            {{ 'Tasks.deadlineLabel' | translate }}: {{ task()?.termEnd | dateFormat: 'DD.MM.YYYY' }}
          </div>
        } @else {
          <div
            class="list-tasks-single-task__info__deadline"
            [class.list-tasks-single-task__info__deadline--overdue]="isOverdue()"
          >
            @if (isOverdue()) {
              <mat-icon fontSet="material-icons-round" aria-hidden="true">schedule</mat-icon>
            }
            @if (!task()?.termStartTheSameTermEnd) {
              {{ task()?.termStart | dateFormat: 'DD MMM' }} - {{ task()?.termEnd | dateFormat: 'DD MMM' }}
            }

            @if (task()?.termStartTheSameTermEnd) {
              {{ task()?.termEnd | dateFormat: 'DD MMM' }}
            }
          </div>
        }
      }

      @if (shouldShowAnyStatusMeta && !simplifiedSubtaskLayout()) {
        <div class="list-tasks-single-task__info__mail-meta">
          @if (latestTaskMetaActorName || latestTaskMetaActorAvatar) {
            <div class="list-tasks-single-task__info__mail-sender">
              <avatar [imageUrl]="latestTaskMetaActorAvatar" [width]="24" [height]="24" [rounded]="true" />
              <span>{{ latestTaskMetaActorName }}</span>
            </div>
          }

          <div
            class="list-tasks-single-task__info__mail-sent-at"
            [class.list-tasks-single-task__info__mail-sent-at--cancelled]="latestTaskMetaIsCancelled"
          >
            @if (shouldShowTaskMailDeliveryState) {
              <span
                class="list-tasks-single-task__info__mail-delivery"
                [floatingPopoverTrigger]="mailDeliveryPopoverTpl"
                [floatingPopoverContext]="taskMailDeliveryPopoverContext"
                [attr.aria-label]="taskMailDeliveryTooltip"
              >
                <svg-icon
                  class="list-tasks-single-task__info__mail-delivery-icon"
                  [src]="taskMailDeliveryState?.iconSrc"
                  [svgStyle]="{ width: '12px', height: '12px' }"
                />
              </span>
            }

            {{ latestTaskMetaLabelKey | translate }}:
            {{ latestTaskMetaDate | dateFormat: 'DD.MM.YYYY - HH:mm' }}

            @if (shouldShowCancelScheduledMailAction) {
              <button
                type="button"
                class="list-tasks-single-task__info__mail-cancel-btn"
                [disabled]="cancelScheduledMailLoading"
                [title]="'Tasks.cancelScheduledMail' | translate"
                (click)="cancelScheduledMail($event)"
              >
                <svg-icon
                  [src]="'./assets/img/close-icon.svg'"
                  [svgStyle]="{ width: '14px', height: '14px' }"
                />
              </button>
            }
          </div>
        </div>
      }
    </div>
    }

    @if (showRemoveAction() && task()?.id) {
      <button type="button" class="list-tasks-single-task__remove" (click)="emitRemoveTask($event)">
        <svg-icon [src]="'/assets/img/ic-trash-red-v2.svg'" />
      </button>
    }
  </div>
</div>

<ng-template #mailDeliveryPopoverTpl let-state let-text="text">
  <div class="list-tasks-single-task__mail-delivery-popover">
    <span class="list-tasks-single-task__mail-delivery-popover__icon">
      <svg-icon [src]="state?.iconSrc" [svgStyle]="{ width: '12px', height: '12px' }" />
    </span>
    <span>{{ text }}</span>
  </div>
</ng-template>

<ng-template #latestCommentPopoverTpl>
  @if (cardLastComment(); as comment) {
    <div class="list-tasks-single-task__last-comment-popover">
      <strong class="list-tasks-single-task__last-comment-popover__title">{{ 'MyWork.Card.lastComment' | translate }}</strong>
      <div class="list-tasks-single-task__last-comment-popover__meta">
        <avatar [width]="28" [rounded]="true" [imageUrl]="commentAuthorAvatar(comment.authorPhoto)" />
        <div class="list-tasks-single-task__last-comment-popover__identity">
          <span class="list-tasks-single-task__last-comment-popover__author">{{ comment.authorName || ('MyWork.Card.unknownAuthor' | translate) }}</span>
          <span class="list-tasks-single-task__last-comment-popover__date">{{ comment.created | dateTimeFormat: 'DD.MM.YYYY, HH:mm' }}</span>
        </div>
      </div>
      <div class="list-tasks-single-task__last-comment-popover__content">{{ comment.content }}</div>
    </div>
  }
</ng-template>

@if (task()?.openedSubtasks) {
  <div
    class="list-tasks-single-task__subtasks-container"
    [ngClass]="{ 'list-tasks-single-task__subtasks-container--opened': task()?.openedSubtasks }"
  >
    <ng-container *ngFor="let subtask of task()?.children; trackBy: identify">
      <list-tasks-single-task
        *ngIf="!subtask?.deleted"
        [task]="subtask"
        [layout]="layout()"
        [groupId]="groupId()"
        [isProcessGroup]="isProcessGroup()"
        [status]="childStatus(subtask)"
        [parentTask]="task()"
        [nestingLevel]="nestingLevel() + 1"
        [hideHierarchyIndicator]="hideHierarchyIndicator()"
        (statusUpdated)="statusUpdated.emit($event)"
        (taskClicked)="taskClicked.emit($event)"
      />
    </ng-container>
  </div>
}
